'use strict';
angular
    .module('components.service', [
        'components.service.loginServiceModule',
        'storageLIstenerModule',
        'trsspliceStringModule',
        'trsModalDialog',
        'trsTransferModule',
        'trsSelectDocumentModule',
        'trsPicturePreviewModule',
        'trsColumnTreeLocation',
        'trsGroupTreeLocation',
        'treeServiceModule',
        'trsLunarDateModule',
        'permissionServiceModule',
        'editPictureServiceModule',
        'previewToolModule',
        'calendarServiceModule',
        'personalFileServiceModule',
        'trsUploadAVNewServiceModule',
        'trsEditVideoServiceModule',
        'trsGetHistoryVideoServiceModule',
        'trsResponseHandleModule',
        'mailListServiceMoudle',
        'angularPlusModule',
        'nProgressModule',
        'messagePublishModule',
        'getFileMD5ServiceModule',
        'noticeWindowServiceModule',
        'pictureSelectorModule',
        'normalDataModule'
    ])
    .factory('globleParamsSet', [
        '$q',
        '$injector',
        '$timeout',
        '$filter',
        // 'trsHttpService',
        'localStorageService',
        '$sessionStorage',
        'fusionParams',
        // 'fusionApiService',
        function ($q, $injector, $timeout, $filter, localStorageService, $sessionStorage, fusionParams) {
            let trsHttpService = $injector.get('trsHttpService');
            let fusionApiService = $injector.get('fusionApiService');
            return {
                getPageSize: function () {
                    var defaultPageSize = 50;
                    return defaultPageSize;
                },
                setResourceCenterPageSize: 20,
                closeDelayTime: 1.5 * 1000, // 关闭页面延迟时间
                digitalNewspaper: 'http://10.100.60.22:7001/login.jsp',
                handlePermissionData: function (_processedData) {
                    var processedData = {};
                    angular.forEach(_processedData, function (data, index, array) {
                        var dataArray = data.split('.');
                        if (angular.isDefined(processedData[dataArray[1]])) {
                            processedData[dataArray[1]][dataArray[2]] = true;
                        } else {
                            processedData[dataArray[1]] = {};
                            processedData[dataArray[1]][dataArray[2]] = true;
                        }
                    });
                    return processedData;
                },

                /**
                 * [arrayContrast description]数组对比合并
                 * @param  {[array]} array1 [description] 数组1
                 * @param  {[array]} array2 [description] 数组2
                 * @param  {[string]} attribute [description] 对比属性1
                 * @param  {[string]} _attribute [description] 对比属性2
                 * @return {[array]}  [description] 合并后的数组
                 */
                arrayContrast: function (array1, array2, attribute, _attribute) {
                    angular.forEach(array1, function (data, index, array) {
                        var flag = true;
                        angular.forEach(array2, function (_data, _index, _array) {
                            if (data[attribute] === _data[attribute] && data[_attribute] === _data[_attribute]) {
                                flag = false;
                            }
                        });
                        if (flag) {
                            array2.push(data);
                        }
                    });
                    return array2;
                },

                /**
                 * [contrastAfExclArray description]对比后剔除数组开始
                 * @param  {[array]} array1 [description] 数组1
                 * @param  {[array]} array2 [description] 数组2
                 * @param  {[string]} attribute [description] 数组1对比属性
                 * @param  {[string]} _attribute [description] 数组2对比属性
                 * @param  {[Fn]} success [description] 回调函数
                 * @return {[null]}  [description]
                 */
                contrastAfExclArray: function (array1, array2, attribute, _attribute, success) {
                    angular.forEach(array1, function (data, index, array) {
                        var i = 0;
                        while (i < array2.length) {
                            if (data[attribute] === array2[i][attribute] && data[_attribute] === array2[i][_attribute]) {
                                array2.splice(i, 1);
                            } else {
                                i++;
                            }
                        }
                    });
                    success(array2);
                },

                /**
                 * [getBigFaceContent description]获取用于大花脸比对的正文
                 * @param  {[array]} htmlContent [description] 数组1
                 * @return {[string]}  [description] 处理过后的正文
                 */
                getBigFaceContent: function (htmlContent) {
                    var dom = document.createElement('div');
                    dom.innerHTML = htmlContent;
                    $(dom)
                        .find('ol')
                        .each(function (index) {
                            $(this)
                                .find('li')
                                .each(function (_index) {
                                    $(this).html(_index + 1 + '.' + $(this).html());
                                });
                        });
                    htmlContent = dom.innerHTML;
                    htmlContent = htmlContent
                        .replace(/<\/p>/g, '\n')
                        .replace(/<\/div>/g, '\n')
                        .replace(/<(p|div)[^>]*>/gi, '')
                        .replace(/<br\/?>/gi, '\n')
                        .replace(/<[^>]+>/g, '')
                        .replace(/&nbsp;/g, '\u3000')
                        .replace(/\u0020/g, '\u3000')
                        .replace(/\n+/g, '\n');
                    if (htmlContent[htmlContent.length - 1] === '\n') {
                        // 去掉文章末尾的换行
                        htmlContent = htmlContent.substring(0, htmlContent.length - 1);
                    }
                    return htmlContent;
                },

                /**
                 * [domObserver description]监控dom节点的变化
                 * @param {object} [dom] [description] 被监控的dom元素
                 * @param {object} [options] [description] {childList:true, subtree:true, attribute:true, attributeOldValue:true,characterData:true}
                 * @param {fn} [callback] [description] 回调函数
                 * @return {[type]} [description]
                 */
                domObserver: function (dom, options, callback) {
                    var promise;
                    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
                    if (angular.isFunction(callback)) {
                        callback('initial');
                    }
                    var mo = new MutationObserver(function (e) {
                        if (promise) {
                            $timeout.cancel(promise);
                            promise = null;
                        }
                        promise = $timeout(function () {
                            if (angular.isFunction(callback)) {
                                callback(e);
                            }
                        }, 100);
                        return promise;
                    });
                    mo.observe(dom, options);
                    return mo;
                },

                /**
                 * [getTenantLogo description] 获取租户Logo
                 * @return {[type]} [description]
                 */
                getTenantLogo: function () {
                    var deffer = $q.defer();
                    var params = {
                        serviceid: 'mlf_tenant',
                        methodname: 'showTenantLogos',
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(
                        function (data) {
                            data.LOGO_1 = !data.LOGO ? './images/logo_1.png' : data.LOGO;
                            data.LOGO_2 = !data.LOGO ? './images/logo_2.png' : data.LOGO;
                            deffer.resolve(data);
                        },
                        function () {
                            deffer.resolve({
                                INTRO: '拓尔思融媒体系统',
                                LOGO_1: './images/logo_1.png',
                                LOGO_2: './images/logo_2.png',
                            });
                        }
                    );
                    return deffer.promise;
                },

                /**
                 * [getTokenService description]获取token
                 * @param  {[num]} tenantId [description]用户租户ID
                 * @return {[type]}         [description]
                 */
                getTokenService: function (tenantId) {
                    var deffer = $q.defer();
                    let daysToExpiryForToken = 0.085;
                    if ($sessionStorage.cookie.get('userToken')) {
                        deffer.resolve({
                            token: $sessionStorage.cookie.get('userToken').token,
                            tenantId: tenantId,
                        });
                        return deffer.promise; // 获得用户token后就不在请求
                    }
                    var params = {
                        serviceid: 'getToken',
                        tenantId: tenantId
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                        $sessionStorage.cookie.set('userToken', data, daysToExpiryForToken);
                        localStorageService.set('userToken', data);
                        deffer.resolve({
                            token: $sessionStorage.cookie.get('userToken').token,
                            tenantId: tenantId,
                        });
                    });
                    return deffer.promise;
                },
                scaleImgSize: function () {
                    return {
                        scaleHeight: 220,
                        scaleWidth: 320,
                    };
                },

                /**
                 * [clearStroge description]清理缓存，一般是切换用户和退出
                 * @return{[type]}[return description]
                 */
                clearStroge: function () {
                    $sessionStorage.remove('currLoginUser');
                    $sessionStorage.remove('mlfCachedUser');
                    $sessionStorage.remove('curUserInfo');
                    localStorageService.remove('userToken'); // 新增清除用户token
                    $sessionStorage.remove('userHeadPic');
                    $sessionStorage.cookie.remove('userToken');
                    $sessionStorage.remove('strongPromtInfo');
                    $sessionStorage.remove('global.strongWindowNewsDailyInfo');
                    $sessionStorage.remove('global.sendNoticeOnlogin');
                    localStorageService.remove('global.loginMark'); // 去除用户登录标识
                },

                /**
                 * [dealImgSrcAfterUpload description]上传后处理图片地址
                 * @param   {[type]}  resp  [resp description]
                 * @return  {[type]}        [return description]
                 */
                dealImgSrcAfterUpload: function (resp) {
                    var imgname = angular.isObject(resp) ? resp.data.imgName : resp;
                    return '/wcm/app/system/read_image.jsp?FileName=' + imgname;
                },

                /**
                 * [dealDropDownData description]处理下拉框数据：trs-single-select指令需要传入的集合中带有name、value等属性
                 * @param  {[array]} data    [description]返回集合
                 * @param  {[str]} nameKey   [description]name对应的值
                 * @param  {[str]} valueKey  [description]value对应的值
                 * @return {[array]}         [description]转换后下拉框组件需要的集合
                 */
                dealDropDownData: function (data, nameKey, valueKey) {
                    for (var i = 0; i < data.length; i++) {
                        data[i].value = data[i][valueKey];
                        data[i].name = data[i][nameKey];
                    }
                    return data;
                },

                /**
                 * [searchByWord description] 根据文字检索
                 * @param   {[object]}  event  [event description] 事件对象
                 * @return  {[type]}           [return description]
                 */
                searchByWord: function (event) {
                    let defer = $q.defer();
                    if ((event && event.keyCode === 13) || !event) {
                        defer.resolve();
                    }
                    return defer.promise;
                },

                /**
                 * [dateFormat description] 格式化时间
                 * @param   {[object]}  date     [date description] 时间对象
                 * @param   {[type]}  separator  [separator description] 分隔符
                 * @return  {[string]}           [return description] 根据分隔符分隔后的时间字符串
                 */
                dateFormat: function (date, separator) {
                    separator = separator ? separator : '-'; // 默认用-分隔
                    var year = date.getFullYear();
                    year = year < 10 ? '0' + year : year + '';
                    var month = date.getMonth() + 1;
                    month = month < 10 ? '0' + month : month + '';
                    var day = date.getDate();
                    day = day < 10 ? '0' + day : day + '';
                    return year + separator + month + separator + day;
                },

                /**
                 * [fewDaysAgo description] 获得几天前的时间
                 * @param   {[number]}  days  [days description] 几天前
                 * @return  {[object]}        [return description] 时间对象
                 */
                fewDaysAgo: function (days) {
                    var date = new Date();
                    var tmp = date.getTime() - 1000 * 60 * 60 * 24 * days;
                    return new Date(tmp);
                },

                /**
                 * [queryRightClassify description]
                 * @param   {[string]}  Classify  [Classify description] 权限分类
                 * @return  {[type]}              [return description]
                 */
                queryRightClassify: function (Classify) {
                    var defer = $q.defer();
                    if (!Classify) {
                        // 存在没有分类的情况 直接退出
                        defer.reject();
                        return defer.promise;
                    }
                    var params = {
                        serviceid: 'mlf_extrole',
                        methodname: 'queryRightClassify',
                        Classify: Classify,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then((data) => {
                        defer.resolve(data);
                    });
                    return defer.promise;
                },

                /**
                 * [filterTime description] 过滤时间
                 * @param   {[object]}  time  [time description] 时间对象
                 * @param   {[string]}  rule  [rule description] 过滤规则
                 * @return  {[string]}        [return description] 过滤后的时间字符串
                 */
                filterTime: function (time, rule) {
                    if (angular.isObject(time)) {
                        return $filter('date')(time, rule).toString();
                    } else {
                        return time;
                    }
                },

                /**
                 * [getServerTime 获取系统时间]
                 * @return  {function}  [return description]
                 */
                getServerTime: function () {
                    var defer = $q.defer();
                    var params = fusionParams.serverTimeParams;
                    fusionApiService.getServerTime(params).then(function (data) {
                        defer.resolve(data);
                    });
                    return defer.promise;
                },

                /**
                 * [exportDraft description] 导出方法
                 * @param   {[object]}  params  [params description] 导出参数
                 * @return  {function}          [return description]
                 */
                exportDraft: function (params) {
                    var defer = $q.defer();
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                        defer.resolve();
                        window.open('/wcm/app/file/read_file.jsp?FileName=' + data);
                    });
                    return defer.promise;
                },

                /**
                 * [whetherLogin description]
                 * @return  {[type]}  [return description]
                 */
                whetherLogin: function () {
                    let userId = $sessionStorage.get('curUserInfo')?.ID || 0;
                    let loginMark = localStorageService.get('global.loginMark');
                    if (loginMark) {
                        return !!loginMark[userId];
                    }
                    else {
                        return false;
                    }
                    // return !!localStorageService.get('global.loginMark');
                }
            };
        },
    ]);
